import React from 'react';
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {OntarioSafeToPlayButtonBox} from "./boxes/ontario.safe-to-play-button.box";
import {CyClass} from "../../../../../../../common/cy-classes";

interface OntarioSafeToPlayButtonComponentProps{
    isShownInHeader: boolean
}

export const OntarioSafeToPlayButtonComponent = observer(class OntarioSafeToPlayButtonComponent extends OrbitComponent<OntarioSafeToPlayButtonComponentProps> {
    private _onClickHandler = async () => {
        this.services.analytics.sendOrbitUserFlowEvent("Navigation","Header", 'Icon_ontario_safe_to_play_icon_click');
        await this.services.linksNavigation.openSafeToPlay();
    }

    render() {
        return (
            <OntarioSafeToPlayButtonBox isShownInHeader={this.props.isShownInHeader} onClick={this._onClickHandler} className={CyClass('cy-safe-to-play')}/>
        )
    }
});